<template>
    <computed-line-chart :node-ids="nodeIdList" :style="heightStyle" :class="folded ? 'folded-chart-cover' : ''">
        <div id="lineChart"></div>
    </computed-line-chart>
</template>

<script>
import ComputedLineChart from "@/components/LayoutMaps/openLayers/stuff/ComputedLineChart";
import stackedMixin from "@/components/LayoutMaps/openLayers/stuff/stackedMixin";

export default {
    name: "ComputedStackLineChart",
    components: {ComputedLineChart},
    mixins: [stackedMixin],
    props: {
        nodeId: [String, Number]
    },
    computed: {
        $_exportData() {
            return {
                nodeIds: this.nodeIdList,
            };
        },
    },
    data() {
        return {
            nodeIdList: [],
        }
    },
    created() {
        this.nodeIdList.push(this.nodeId);
    },
    methods: {
        $_stackIntoLocale() {
            let nodeIds = this.exportChartData.nodeIds;
            if (nodeIds) {
                for (let item of nodeIds) {
                    if (this.nodeIdList.some(f => f === item)) {
                        continue;
                    }
                    this.nodeIdList.push(item);
                }
            }
        },
    }
}
</script>

<style scoped>
.folded-chart-cover {
    overflow: visible !important;
}
</style>